"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const LayoutVisualizerBlocks_1 = require("./LayoutVisualizerBlocks");
const react_2 = require("@osmosys/react");
class LayoutVisualizer extends react_1.default.Component {
    render() {
        const { isOpen, blocks } = this.props;
        return (react_1.default.createElement(react_2.OsmosysModal, { osysName: "LayoutVisualizer", isOpen: isOpen, toggle: () => this.props.toggle(false) },
            react_1.default.createElement(reactstrap_1.ModalBody, { className: "bg-dark" },
                react_1.default.createElement(LayoutVisualizerBlocks_1.LayoutVisualizerBlocks, { blocks: blocks }))));
    }
}
exports.LayoutVisualizer = LayoutVisualizer;
//# sourceMappingURL=LayoutVisualizer.js.map